import AdminLayout from "../components/AdminLayout";
import TableRequest from "../components/TableRequest";

function Request() {
  return (
    <AdminLayout title="Requests" stats="default">
      <TableRequest />
    </AdminLayout>
  );
}

export default Request;
